"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _job = require("@/api/job/job");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _screenfull = _interopRequireDefault(require("screenfull"));
var _TimeExpressionValidator = _interopRequireDefault(require("./components/TimeExpressionValidator"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// base on element-ui
// secondary package based on el-pagination
var _default = exports.default = {
  name: "任务管理",
  components: {
    Pagination: _Pagination.default,
    TimeExpressionValidator: _TimeExpressionValidator.default
  },
  directives: {
    waves: _waves.default,
    elDragDialog: _elDragDialog.default
  },
  data: function data() {
    return {
      tableKey: 0,
      labelPosition: "right",
      list: [],
      total: 0,
      listLoading: true,
      disabledStatus: false,
      listQuery: {
        index: 0,
        pageSize: 10,
        jobId: undefined,
        appId: undefined,
        keyword: undefined
      },
      modifiedJobForm: {
        id: undefined,
        jobName: "",
        jobDescription: "",
        appId: 3,
        jobParams: "",
        timeExpressionType: "",
        timeExpression: "",
        executeType: "",
        processorType: "",
        processorInfo: "",
        maxInstanceNum: 0,
        concurrency: 5,
        instanceTimeLimit: 0,
        instanceRetryNum: 0,
        taskRetryNum: 1,
        minCpuCores: 0,
        minMemorySpace: 0,
        minDiskSpace: 0,
        enable: true,
        designatedWorkers: "",
        maxWorkerCount: 0,
        notifyUserIds: []
      },
      userRegisterForm: {
        id: undefined,
        username: undefined,
        email: undefined,
        phone: undefined,
        webHook: undefined
      },
      dialogFormVisible: false,
      alarmDialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: '编辑',
        create: '新增'
      },
      rules: {
        jobName: [{
          required: true,
          validator: this.checkJobName,
          trigger: ["blur", "change"]
        }],
        scheduleInfo: [{
          required: true,
          validator: this.checkScheduleInfo,
          trigger: ["blur", "change"]
        }],
        executeConfig: [{
          required: true,
          validator: this.checkExecuteConfig,
          trigger: ["blur", "change"]
        }],
        username: [{
          required: true,
          validator: this.checkUsername,
          trigger: ["blur", "change"]
        }],
        email: [{
          required: true,
          validator: this.checkEmail,
          trigger: ["blur", "change"]
        }],
        mobile: [{
          required: false,
          validator: this.checkMobile,
          trigger: ["blur", "change"]
        }]
      },
      downloadLoading: false,
      columnHeaders: [{
        index: 0,
        title: '任务ID',
        isShow: true
      }, {
        index: 1,
        title: '任务名称',
        isShow: true
      }, {
        index: 2,
        title: '定时信息',
        isShow: true
      }, {
        index: 3,
        title: '执行类型',
        isShow: true
      }, {
        index: 4,
        title: '处理器类型',
        isShow: true
      }, {
        index: 5,
        title: '状态',
        isShow: true
      }],
      initColumnCheckeds: ['任务ID', '任务名称', '定时信息', '执行类型', '处理器类型', '状态'],
      columnCheckeds: ['任务ID', '任务名称', '定时信息', '执行类型', '处理器类型', '状态'],
      checkAll: true,
      isIndeterminate: true,
      switchClass: "down",
      // 时间表达式类型
      timeExpressionTypeOptions: [{
        key: "API",
        label: "API"
      }, {
        key: "CRON",
        label: "CRON"
      }, {
        key: "FIXED_RATE",
        label: "固定频率（毫秒）"
      }, {
        key: "FIXED_DELAY",
        label: "固定延迟（毫秒）"
      }, {
        key: "WORKFLOW",
        label: "工作流"
      }],
      // 处理器类型
      processorTypeOptions: [{
        key: "BUILT_IN",
        label: "内建"
      }, {
        key: "EXTERNAL",
        label: "外置（动态加载）"
      }],
      // { key: 'SHELL', label: 'SHELL' }, { key: 'PYTHON', label: 'PYTHON' }
      // 执行方式类型
      executeTypeOptions: [{
        key: "STANDALONE",
        label: "单机执行"
      }, {
        key: "BROADCAST",
        label: "广播执行"
      }, {
        key: "MAP",
        label: "Map执行"
      }, {
        key: "MAP_REDUCE",
        label: "MapReduce执行"
      }],
      // 用户列表
      userList: [],
      // 时间表达式校验窗口
      timeExpressionValidatorVisible: false
    };
  },
  watch: {
    columnCheckeds: function columnCheckeds(newArrayVal) {
      var _this = this;
      var nonSelecteds = this.columnHeaders.filter(function (item) {
        return newArrayVal.indexOf(item.title) === -1;
      }).map(function (item) {
        return item.title;
      });
      // 根据计算结果进行表格重绘
      this.columnHeaders.filter(function (item) {
        var isNonSelected = nonSelecteds.indexOf(item.title) !== -1;
        if (isNonSelected) {
          // 隐藏未选中的列
          item.isShow = false;
          _this.$nextTick(function () {
            _this.$refs.multipleTable.doLayout();
          });
        } else {
          // 显示已选中的列
          item.isShow = true;
          _this.$nextTick(function () {
            _this.$refs.multipleTable.doLayout();
          });
        }
      });
    }
  },
  created: function created() {
    if (window.innerWidth < 700) {
      this.labelPosition = "top";
    }
    this.getList();
  },
  methods: {
    // 转换执行类型
    translateExecuteType: function translateExecuteType(executeType) {
      switch (executeType) {
        case "STANDALONE":
          return "单机执行";
        case "BROADCAST":
          return "广播执行";
        case "MAP":
          return "Map执行";
        case "MAP_REDUCE":
          return "MapReduce执行";
        default:
          return "UNKNOWN";
      }
    },
    // 转换处理器类型
    translateProcessorType: function translateProcessorType(processorType) {
      if (processorType === "EXTERNAL") {
        return "外置（动态加载）";
      }
      return "内建";
    },
    verifyPlaceholder: function verifyPlaceholder(processorType) {
      var res;
      switch (processorType) {
        case "BUILT_IN":
          res = "全限定类名,eg:com.chinatechstar.job.processors.MapReduceProcessor";
          break;
        case "EXTERNAL":
          res = "容器ID#全限定类名,eg:1#com.chinatechstar.job.processors.MapReduceProcessor";
          break;
        case "SHELL":
          res = "SHELL脚本文件内容";
          break;
        case "PYTHON":
          res = "Python脚本文件内容";
      }
      return res;
    },
    // 点击校验
    onClickValidateTimeExpression: function onClickValidateTimeExpression() {
      if (this.modifiedJobForm.timeExpressionType !== "CRON" || !this.modifiedJobForm.timeExpression) {
        this.handleWarning('请选择CRON时间表达式类型，并输入CRON表达式！');
      } else {
        this.timeExpressionValidatorVisible = true;
      }
    },
    getList: function getList(data) {
      var _this2 = this;
      this.listLoading = true;
      this.listQuery.appId = 3;
      if (data) {
        this.listQuery.index = data.page - 1;
        this.listQuery.pageSize = data.limit;
      }
      console.log('getList 调用时的 listQuery:', JSON.parse(JSON.stringify(this.listQuery)));
      console.log('getList 接收到的 data:', data);
      (0, _job.queryUserList)().then(function (response) {
        _this2.userList = response.data.data;
      });
      (0, _job.queryJobInfo)(this.listQuery).then(function (response) {
        if (response.data.success === true) {
          _this2.list = response.data.data.data;
          _this2.total = response.data.data.totalItems;
          _this2.listQuery.index = response.data.data.index + 1;
          console.log('后端返回的数据列表长度:', _this2.list.length);
          console.log('后端返回的 totalItems:', _this2.total);
          console.log('当前 pageSize:', _this2.listQuery.pageSize);
        } else {
          _this2.handleWarning(response.data.message);
        }
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.index = 0;
      this.getList();
    },
    handleReset: function handleReset() {
      this.listQuery.jobId = undefined;
      this.listQuery.keyword = undefined;
      this.handleFilter();
    },
    handleFullscreen: function handleFullscreen() {
      var element = document.getElementById("screenfull-container");
      if (_screenfull.default.enabled) {
        _screenfull.default.request(element);
      }
      _screenfull.default.toggle();
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.columnCheckeds = val ? this.initColumnCheckeds : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange: function handleCheckedChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnHeaders.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnHeaders.length;
    },
    changeJobStatus: function changeJobStatus(data) {
      var _this3 = this;
      // switch 自动更改 enable 的值
      if (data.enable === false) {
        // 若有特殊逻辑，例如关闭秒级任务，则执行
        (0, _job.switchJobInfo)(data.id).then(function (response) {
          if (response.data.success === true) {
            _this3.$message({
              message: "切换成功",
              type: "success",
              duration: 2000
            });
            _this3.handleReset();
          } else {
            _this3.handleWarning(response.data.message);
          }
        });
      } else {
        // 启用，则发起正常的保存操作
        this.modifiedJobForm = data;
        (0, _job.saveJobInfo)(this.modifiedJobForm).then(function (response) {
          if (response.data.success === true) {
            _this3.$message({
              message: "切换成功",
              type: "success",
              duration: 2000
            });
            _this3.handleReset();
          } else {
            _this3.handleWarning(response.data.message);
          }
        });
      }
    },
    handleCreate: function handleCreate() {
      var _this4 = this;
      this.dialogStatus = "create";
      this.modifiedJobForm.id = undefined;
      this.modifiedJobForm.jobName = undefined;
      this.modifiedJobForm.jobDescription = undefined;
      this.modifiedJobForm.jobParams = undefined;
      this.modifiedJobForm.timeExpression = undefined;
      this.modifiedJobForm.timeExpressionType = undefined;
      this.modifiedJobForm.processorInfo = undefined;
      this.modifiedJobForm.processorType = undefined;
      this.modifiedJobForm.executeType = undefined;
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        if (_this4.$refs["dataForm"]) {
          _this4.$refs["dataForm"].clearValidate();
        }
      });
    },
    saveJob: function saveJob() {
      var _this5 = this;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this5.disabledStatus = true;
          (0, _job.saveJobInfo)(_this5.modifiedJobForm).then(function (response) {
            if (response.data.success === true) {
              _this5.list.unshift(_this5.modifiedJobForm);
              _this5.disabledStatus = false;
              _this5.dialogFormVisible = false;
              _this5.$message({
                message: _this5.dialogStatus === "create" ? "新增成功" : "编辑成功",
                type: "success",
                duration: 2000
              });
              _this5.handleReset();
            } else {
              _this5.handleWarning(response.data.message);
            }
          });
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this6 = this;
      this.modifiedJobForm = JSON.parse(JSON.stringify(row));
      var intNotifyUserIds = [];
      if (this.modifiedJobForm.notifyUserIds && this.modifiedJobForm.notifyUserIds.length > 0) {
        this.modifiedJobForm.notifyUserIds.forEach(function (value) {
          intNotifyUserIds.push(parseInt(value));
        });
      }
      this.modifiedJobForm.notifyUserIds = intNotifyUserIds;
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        if (_this6.$refs["dataForm"]) {
          _this6.$refs["dataForm"].clearValidate();
        }
      });
    },
    handleValidate: function handleValidate() {
      return true;
    },
    handleCopy: function handleCopy() {
      var _this7 = this;
      if (!this.handleValidate()) {
        return;
      }
      (0, _job.copyJobInfo)(this.multipleSelection[0].id).then(function (response) {
        if (response.data.success === true) {
          _this7.modifiedJobForm = response.data.data;
          _this7.dialogFormVisible = true;
        } else {
          _this7.handleWarning(response.data.message);
        }
      });
    },
    handleCopyRow: function handleCopyRow(row) {
      var _this8 = this;
      this.$confirm('确定要复制此任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _job.copyJobInfo)(row.id).then(function (response) {
          if (response.data.success === true) {
            _this8.modifiedJobForm = response.data.data;
            _this8.dialogFormVisible = true;
            _this8.$message({
              message: '复制成功',
              type: 'success',
              duration: 2000
            });
          } else {
            _this8.handleWarning(response.data.message);
          }
        });
      }).catch(function () {
        // 用户取消
      });
    },
    handleRun: function handleRun() {
      var _this9 = this;
      if (!this.handleValidate()) {
        return;
      }
      this.listQuery.appId = 3;
      this.listQuery.jobId = this.multipleSelection[0].id;
      (0, _job.runJobInfo)(this.listQuery).then(function (response) {
        if (response.data.success === true) {
          _this9.$message({
            message: "运行成功",
            type: "success",
            duration: 2000
          });
          _this9.handleReset();
        } else {
          _this9.handleWarning(response.data.message);
        }
      });
    },
    handleRunRow: function handleRunRow(row) {
      var _this0 = this;
      this.listQuery.appId = 3;
      this.listQuery.jobId = row.id;
      (0, _job.runJobInfo)(this.listQuery).then(function (response) {
        if (response.data.success === true) {
          _this0.$message({
            message: "运行成功",
            type: "success",
            duration: 2000
          });
          _this0.handleReset();
        } else {
          _this0.handleWarning(response.data.message);
        }
      });
    },
    handleRunHistory: function handleRunHistory() {
      if (!this.handleValidate()) {
        return;
      }
      this.$router.push({
        path: "/job/taskInstance",
        query: {
          jobId: this.multipleSelection[0].id
        }
      });
    },
    handleRunHistoryRow: function handleRunHistoryRow(row) {
      this.$router.push({
        path: "/job/taskInstance",
        query: {
          jobId: row.id
        }
      });
    },
    handleAlarm: function handleAlarm() {
      var _this1 = this;
      this.userRegisterForm.username = undefined;
      this.userRegisterForm.email = undefined;
      this.userRegisterForm.phone = undefined;
      this.userRegisterForm.webHook = undefined;
      this.alarmDialogFormVisible = true;
      this.$nextTick(function () {
        if (_this1.$refs["alarmDataForm"]) {
          _this1.$refs["alarmDataForm"].clearValidate();
        }
      });
    },
    registerAlarmUser: function registerAlarmUser() {
      var _this10 = this;
      this.$refs["alarmDataForm"].validate(function (valid) {
        if (valid) {
          _this10.disabledStatus = true;
          (0, _job.saveUser)(_this10.userRegisterForm).then(function (response) {
            if (response.data.success === true) {
              _this10.disabledStatus = false;
              _this10.alarmDialogFormVisible = false;
              _this10.$message({
                message: "录入成功",
                type: "success",
                duration: 2000
              });
              _this10.handleReset();
            } else {
              _this10.handleWarning(response.data.message);
            }
          });
        }
      });
    },
    // handleDelete(row, index) {
    //   if (row.id) {
    //     this.delete(row.id);
    //   } else {
    //     if (this.multipleSelection.length === 0) {
    //       this.handleWarning("请勾选需要删除的记录！");
    //       return;
    //     }
    //     this.$confirm("确定删除该些记录吗？", "批量删除", {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning"
    //     })
    //       .then(() => {
    //         this.delete(
    //           this.multipleSelection
    //             .map(item => {
    //               return item.id;
    //             })
    //             .join(",")
    //         );
    //       })
    //       .catch(() => {});
    //   }
    // },
    delete: function _delete(deleteArray) {
      // deleteJobInfo(deleteArray).then(response => {
      //   if (response.data.success === true) {
      //     this.$message({
      //       message: '刪除成功',
      //       type: "success",
      //       duration: 2000
      //     });
      //     this.handleReset();
      //   } else {
      //     this.handleWarning(response.data.message);
      //   }
      // });
    },
    handleWarning: function handleWarning(response) {
      this.$message({
        message: response,
        type: "warning",
        duration: 2000
      });
      this.disabledStatus = false;
    },
    checkJobName: function checkJobName(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入任务名称！"));
      } else {
        callback();
      }
    },
    checkScheduleInfo: function checkScheduleInfo(rule, value, callback) {
      if (this.modifiedJobForm.timeExpressionType === "API" || this.modifiedJobForm.timeExpressionType === "WORKFLOW") {
        callback();
      } else {
        if (!this.modifiedJobForm.timeExpressionType || !this.modifiedJobForm.timeExpression) {
          return callback(new Error("请输入定时信息！"));
        } else {
          callback();
        }
      }
    },
    checkExecuteConfig: function checkExecuteConfig(rule, value, callback) {
      if (!this.modifiedJobForm.executeType || !this.modifiedJobForm.processorType || !this.modifiedJobForm.processorInfo) {
        return callback(new Error("请输入执行配置！"));
      } else {
        callback();
      }
    },
    checkUsername: function checkUsername(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入用户名！"));
      } else {
        callback();
      }
    },
    checkEmail: function checkEmail(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入邮箱地址！"));
      } else {
        var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的邮箱地址！'));
        }
      }
    },
    checkMobile: function checkMobile(rule, value, callback) {
      if (this.userRegisterForm.phone) {
        var reg = /^1\d{10}$/;
        if (reg.test(this.userRegisterForm.phone)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号！"));
        }
      } else {
        callback();
      }
    }
  }
};